import { css, Theme } from '@emotion/react'

export const inputLabelWrapper = css`
  display: block;
  margin-top: 26px;
`

export const inputLabel = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
  text-align: left;
  font-style: italic;
`

export const input = css`
  font-style: italic;
`
